import { Box, Paper, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { List } from "@mui/icons-material";
import {
  ObjSumario,
  PopulacaoZas,
  SalaControle,
  Sumario,
  TableAcomodacoes
} from "../../components";
import '@mdxeditor/editor/style.css';
import { useBarragemContext, useUserContext } from "../../context";

export const SectionII: React.FC = () => {
  const theme = useTheme();
  const { barragem } = useBarragemContext();
  const user = useUserContext();

  const [showSumario, setShowSumario] = useState(true);
  const [screen, setScreen] = useState<JSX.Element>(<SalaControle />);
  const [itemsSumario, setItemsSumario] = useState<ObjSumario[]>([]);

  useEffect(() => {
    if (!barragem || "error" in barragem) return;
    if (!user || "error" in user) return;

    setItemsSumario([
      {
        title: "Sala de Controle",
        type: "title",
        screen: <SalaControle />,
      },
      {
        title: "Cadastro da População na ZAS",
        type: "title",
        screen: <PopulacaoZas />,
      },
      {
        title: "Locais para Acomodação das Pessoas Evacuadas",
        type: "title",
        screen: <TableAcomodacoes />,
      },
    ]);

  }, [barragem, user]);


  return <Box sx={{
    py: "1em",
    pr: "1em",
    gap: "0.5em",
    width: `100%`,
    height: `100%`,
    display: "flex",
    flexDirection: "row",
    pl: showSumario ? "1em" : 0,
  }}>

    {/* Sumário */}
    {showSumario &&
      <Box sx={{
        width: "25%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
      }}>
        <Sumario
          items={itemsSumario}
          onSelect={(item) => item.screen && setScreen(item.screen)}
          onClose={() => setShowSumario(false)}
        />
      </Box>
    }

    {/* Botão para abrir o sumário, quando fechado */}
    {!showSumario &&
      <div
        onClick={() => setShowSumario(true)}
        style={{
          padding: "5px",
          position: 'relative',
          display: "flex",
          height: "46px",
          width: "46px",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.palette.background.paper,
          border: "1px solid black",
          borderTopRightRadius: "50%",
          borderBottomRightRadius: "50%",
          boxShadow: "10px",
          top: 5,
          left: 0,
          zIndex: 10000,
        }}
      >
        <List />
      </div>
    }

    {/* Editor */}
    <Paper elevation={0} sx={{
      flex: 1,
      width: "100%",
      height: "100%",
      textAlign: "justify",
      p: "15px",
    }}>
      {screen}
    </Paper>
  </Box >;
};
